import { memo } from "react";
import { ECommerce } from "ui/organizms/Onboarding";

const UBOIdentityVerification = () => (
    <ECommerce.UBOIdentityVerification />
);

export default memo(UBOIdentityVerification);
